module.exports = "pegasus/assets/web_template/hamburger.png";